<!-- 菜单管理-->
<template>
<div>
  <x-menu></x-menu>
</div>
</template>

<script>
import { menu } from 'ant-design-vue-admin-x';
export default {
  name: 'manageMenu',
  components: {
    XMenu: menu
  }
};
</script>
